export default function addPdfLinkHandlers() {
    let downloadPdfComponent = document.getElementsByClassName("quick-downloads");

    if (!downloadPdfComponent)
        return;

    //Since there could be multiple components with the quick-downloads section:
    downloadPdfComponent.forEach(component => {

        let pdfLinks = component.getElementsByClassName(
            "pdf-login-prompt js-global-modal-link",
        );
        if (pdfLinks) {
            pdfLinks.forEach(link => {
                link.addEventListener("click", setRequestedPdf);
            });
        }

        function setRequestedPdf(event) {
            const target = event.target;
            const requestedPdf = target.getAttribute("data-requested-pdf");
            const requestedPdfTitle = target.getAttribute("data-requested-pdf-title");

            let params = new URLSearchParams(window.location.search);
            params.set("requestedPdfUrl", requestedPdf);
            params.set("requestedPdfTitle", requestedPdfTitle);

            let newQuery = window.location.pathname + "?" + params.toString();
            window.history.pushState(null, "", newQuery);
        }

        //Get each select/button pair
        let quickDownloadsSelectContainer = component.querySelectorAll(".quick-downloads-select-container");
        if (!quickDownloadsSelectContainer)
            return;

        //Foreach select/button pari
        quickDownloadsSelectContainer.forEach(quickDownloadsSelect => {

            //Get lang select
            let langSelector = quickDownloadsSelect.querySelector(".quick-downloads-select");

            if (langSelector) {
                langSelector.addEventListener("change", handlePdfLanguageSelection);
            }

            function handlePdfLanguageSelection(event) {
                const target = event.target;

                //login prompt section
                //Set lang url to data attribute
                var loginDwnldLinks = quickDownloadsSelect.querySelector("a.js-global-modal-link");
                if (loginDwnldLinks) {
                    loginDwnldLinks.setAttribute("data-requested-pdf", target.value);
                }

                //download link section
                //Set lang url to href attribute
                var downloadLinks = quickDownloadsSelect.querySelector("a.pdf-download-link");
                if (downloadLinks) {
                    downloadLinks.setAttribute("href", target.value);
                }
            }
        });
    });
}